import { SortOption } from './ResultSortDropdown';

export const sortOptions: SortOption[] = [
  // Claims
  {
    label: 'Highest Claims',
    order: 'desc',
    sort: 'claims',
  },
  {
    label: 'Lowest Claims',
    order: 'asc',
    sort: 'claims',
  },
  // Total Payments
  {
    label: 'Highest Total Payments',
    order: 'desc',
    sort: 'total_payments',
  },
  {
    label: 'Lowest Total Payments',
    order: 'asc',
    sort: 'total_payments',
  },
  // Patients
  {
    label: 'Most Patients',
    order: 'desc',
    sort: 'patients',
  },
  {
    label: 'Fewest Patients',
    order: 'asc',
    sort: 'patients',
  },
  // Name
  {
    label: 'Name (A-Z)',
    order: 'asc',
    sort: 'name',
  },
  {
    label: 'Name (Z-A)',
    order: 'desc',
    sort: 'name',
  },
  // Location and Classification
  {
    label: 'City (A-Z)',
    order: 'asc',
    sort: 'city',
  },
  {
    label: 'City (Z-A)',
    order: 'desc',
    sort: 'city',
  },
  {
    label: 'State (A-Z)',
    order: 'asc',
    sort: 'state',
  },
  {
    label: 'State (Z-A)',
    order: 'desc',
    sort: 'state',
  },
  {
    label: 'Specialty (A-Z)',
    order: 'asc',
    sort: 'specialty',
  },
  {
    label: 'Specialty (Z-A)',
    order: 'desc',
    sort: 'specialty',
  },
];
